var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:_vm.$style.container,attrs:{"fluid":""}},[_c('v-row',{class:_vm.$style.wrapper},[_c('v-col',{attrs:{"sm":"12","cols":"12"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }